<template>
  <div class="account-create-section">
    <b-card>
      <div v-if="mode === 'create'">
        <h2 class="m__b--25">
          Create Account
        </h2>
        <b-form>
          <b-form-group label="Username">
            <b-form-input v-model="itemData.username" placeholder="Username" />
          </b-form-group>
          <b-form-group label="Name">
            <b-form-input v-model="itemData.name" placeholder="Name" />
          </b-form-group>
          <b-form-group label="Password" v-if="mode === 'create'">
            <b-form-input
              v-model="itemData.password"
              placeholder="Password"
              type="password"
            />
          </b-form-group>
          <b-form-group label="Role">
            <vue-treeselect
              valueFormat="object"
              :options="roles"
              v-model="itemData.role"
              placeholder="Role"
            />
          </b-form-group>
          <b-form-group label="Email">
            <b-form-input v-model="itemData.email" placeholder="Email" />
          </b-form-group>
          <b-form-group label="Location">
            <vue-treeselect
              valueFormat="object"
              :options="optionsLocation"
              v-model="itemData.location_id"
              placeholder="Location"
            />
          </b-form-group>
        </b-form>
      </div>

      <b-tabs v-else content-class="mt-3" fill>
        <b-tab title="Edit Account" active @click="toggleTabs('account')">
          <b-form>
            <b-form-group label="Username">
              <b-form-input
                v-model="itemData.username"
                placeholder="Username"
              />
            </b-form-group>
            <b-form-group label="Name">
              <b-form-input v-model="itemData.name" placeholder="Name" />
            </b-form-group>
            <b-form-group label="Password" v-if="mode === 'create'">
              <b-form-input
                v-model="itemData.password"
                placeholder="Password"
                type="password"
              />
            </b-form-group>
            <b-form-group label="Role">
              <vue-treeselect
                valueFormat="object"
                :options="roles"
                v-model="itemData.role"
                placeholder="Role"
              />
            </b-form-group>
            <b-form-group label="Email">
              <b-form-input v-model="itemData.email" placeholder="Email" />
            </b-form-group>
            <b-form-group label="Location">
              <vue-treeselect
                valueFormat="object"
                :options="optionsLocation"
                v-model="itemData.location_id"
                placeholder="Location"
              />
            </b-form-group>
          </b-form>
        </b-tab>
        <b-tab title="Reset Password" @click="toggleTabs('password')">
          <b-form v-if="currentData === 'password'">
            <b-form-group label="New Password">
              <b-form-input
                v-model="itemData.password"
                placeholder="Password"
                type="password"
              />
            </b-form-group>
            <b-form-group label="Confirm New Password">
              <b-form-input
                v-model="itemData.confirm_password"
                placeholder="Confirm New Password"
                type="password"
              />
            </b-form-group>
          </b-form>
        </b-tab>
      </b-tabs>
    </b-card>

    <div class="float-to-right m__t--55 m__b--60">
      <b-button
        class="m__r--10 cancel"
        @click="$router.replace('/home/account')"
        >Cancel</b-button
      >
      <b-button class="save" @click="save">Save</b-button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
// import Store from '@/stores';
export default {
  name: 'Account',
  data() {
    return {
      mode: 'create',
      currentData: 'account',
      itemData: {
        id: 0,
        name: null,
        role: null,
        username: null,
        password: null,
        confirm_password: null,
        email: null,
        location_id: null
      },

      roles: [
        {
          label: 'Superadmin',
          id: 'SUPERADMIN'
        },
        {
          label: 'Admin',
          id: 'ADMIN'
        },
        {
          label: 'Cashier',
          id: 'CASHIER'
        },
        {
          label: 'Ops',
          id: 'OPS'
        }
      ]
    };
  },
  watch: {
    'accountState.detail': function(newVal) {
      console.log(newVal, 'sadadsd');
      this.itemData = {
        id: newVal.id,
        name: newVal.name,
        username: newVal.username,
        role: { id: newVal.role, label: newVal.role },
        password: newVal.password,
        confirm_password: null,
        email: newVal.email,
        location_id: newVal.location_id ? { id: newVal.location_id } : { id: 0 }
      };
    }
  },
  computed: {
    ...mapGetters('StoreLocation', ['optionsLocation']),
    ...mapState('StoreAccount', ['accountState'])
  },
  created() {
    const req = {
      sort: 'name',
      per_page: 100,
      page: 1,
      search: ''
    };
    this.$store.dispatch('StoreLocation/listLocation', req);
    if (this.$route.path.includes('reset-password')) {
      this.currentData = 'password';
      this.mode = 'edit';
      this.$store.dispatch('StoreAccount/detailAccount', {
        id: this.$route.params.id
      });
    } else if (this.$route.path.includes('create')) {
      this.mode = 'create';
    } else {
      this.mode = 'edit';
      this.$store.dispatch('StoreAccount/detailAccount', {
        id: this.$route.params.id
      });
    }
  },
  methods: {
    toggleTabs(data) {
      this.currentData = data;
    },
    save() {
      const req = {
        id: this.$route.params.id,
        username: this.itemData.username,
        name: this.itemData.name,
        role: this.itemData.role ? this.itemData.role.id : '',
        password: this.itemData.password,
        email: this.itemData.email,
        location_id: this.itemData.location_id
          ? this.itemData.location_id.id === 0
            ? undefined
            : this.itemData.location_id.id
          : ''
      };
      if (this.mode === 'create') {
        this.$store.dispatch('StoreAccount/createAccount', req);
      } else if (this.currentData === 'account') {
        this.$store.dispatch('StoreAccount/editAccount', req);
      } else {
        if (this.itemData.password === this.itemData.confirm_password) {
          this.$store.dispatch('StoreAccount/editAccountPassword', req);
        } else {
          this.$notify({
            group: 'notif',
            type: 'error',
            title: 'Error',
            text: 'Confirm password is not match, Please Try Again'
          });
        }
      }
      // this.$store.dispatch('StoreAccount/createAccount', this.itemData);
    }
  }
};
</script>

<style lang="scss">
.account-create-section {
  h2 {
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 37px;
    color: #1d2d4e;
  }
  legend {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 37px;
    color: #1d2d4e;
  }
  .form-control::placeholder {
    color: #bdbdbd;
  }
  button {
    width: 147px;
    height: 45px;
    border-radius: 3px;
    border: unset;
    &.cancel {
      background: #ffffff;
      box-shadow: 0px 4px 20px #f0efec;
      color: #ababab;
    }
    &.save {
      background: #fb9c0a;
      box-shadow: 0px 4px 20px rgba(251, 156, 10, 0.3);
    }
  }
}
</style>
